"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSubscriptionImpl = void 0;
const exception_1 = require("@almservices-cl/exception");
const asyncIterate_1 = __importDefault(require("../Util/asyncIterate"));
class NetworkSubscriptionImpl {
    constructor(logger) {
        this.subscriptions = [];
        this._isOffline = null;
        this.init = async (isOffline) => {
            this._isOffline = isOffline;
            this.callSubscriptions();
        };
        this.goOffline = async () => {
            this.validate();
            this._isOffline = true;
            await this.callSubscriptions();
        };
        this.goOnline = async () => {
            this.validate();
            this._isOffline = false;
            await this.callSubscriptions();
        };
        this.subscribe = (subscription) => {
            this.subscriptions.push(subscription);
            if (this._isOffline !== null) {
                subscription(this._isOffline).catch(this.logger.error);
            }
        };
        this.validate = () => {
            if (this._isOffline === null) {
                throw new exception_1.IllegalStateException("Network Period was not init yet");
            }
        };
        this.callSubscriptions = async () => {
            await (0, asyncIterate_1.default)(this.subscriptions, (subscription) => subscription(this._isOffline));
        };
        this.logger = logger;
    }
}
exports.NetworkSubscriptionImpl = NetworkSubscriptionImpl;
//# sourceMappingURL=NetworkSubscription.js.map